import React from 'react';

import { Image } from '@/shared/ui';

import Accordion from '../../../../components/Accordion/Accordion';
import { InsuranceOrganizationProduct } from '../../shared/model/types';

import './InsuranceProductsList.scss';

interface Props {
  insuranceProducts: InsuranceOrganizationProduct[];
}

export const InsuranceProductsList = React.memo<Props>(function ({ insuranceProducts }) {
  return (
    <div className="insurance-products-list">
      <Accordion
        bordered={false}
        accordion={false}
        withMargin={false}
        accordionData={insuranceProducts.map((insuranceProduct) => ({
          className: 'insurance-products-list__item insurance-product',
          title: (
            <div className="insurance-product__title">
              <div className="insurance-product__logo">
                <Image src={insuranceProduct.organization.logo_url} alt="insurance company logo" />
              </div>
              <div className="insurance-product__price">
                <div>Загальна сума</div>
                <div>{insuranceProduct.price} грн</div>
              </div>
            </div>
          ),
          content: (
            <div className="insurance-product__content">
              <div className="insurance-product__description">
                <div>Деталі</div>
                <div dangerouslySetInnerHTML={{ __html: insuranceProduct.description }} />
              </div>
            </div>
          ),
        }))}
      />
    </div>
  );
});
